export const manageTooltips = () => {
  let tooltips = document.getElementsByClassName('tooltiped')
  let index = 0

  for (let tooltip of tooltips) {
    const id = 'tooltip' + index
    const element = document.getElementById(id)
    index++

    if (!element) {
      const textNode = document.createElement('p')

      textNode.textContent = tooltip.dataset.text
      textNode.classList.add('tooltiptext')
      textNode.id = id

      tooltip.appendChild(textNode)
    } else if (element && !tooltip.dataset.text) {
      tooltip.removeChild(element)
    }
  }
}
